import React from 'react';

function NotFound() {
    return (
        <div>
            404 Page not found
        </div>
    );
}

export default NotFound;
